<template>
    <div class="container">
        <div class="pageTitle">添加文件</div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item label="文件分类:" prop="category_id1">
                <el-col :span="3" v-if="!cateLevelOneName">
                    <el-select clearable v-model="form.category_id1" placeholder="请选择一级分类" @change="selectCateOne">
                        <el-option v-for=" i in categoryOne" :key="i.id" :label="i.name"
                                   :value="i.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="1" style="text-align: center">-</el-col>
                <el-col :span="3" v-if="!cateLevelOneName">
                    <el-select clearable v-model="form.category_id2" placeholder="请选择二级分类">
                        <el-option v-for=" i in categoryTwo" :key="i.id" :label="i.name"
                                   :value="i.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="2" v-if="cateLevelOneName">
                    {{cateLevelOneName}} > {{cateLevelTwoName}}
                    <span class="fa  fa-pencil" style="color: black;cursor: pointer;margin-left: 10px" @click="selectCate()"></span>
                </el-col>
                <el-button style="margin: 0 20px;" @click="refresh()">刷新</el-button>
                <router-link to='./liabraryCate' target='_blank' style="color: blue;cursor: pointer">添加分类</router-link>
                <!--  <span style="color: blue;cursor: pointer" @click="addCate()">添加分类</span>-->
            </el-form-item>
            <el-form-item label="文件名称:" prop="name">
                  <el-col :span="10">
                      <el-input type="textarea" v-model="form.name" readonly></el-input>
                  </el-col>
                <el-col :span="3" style="margin-left: 20px">
                    <el-upload
                            class="upload-demo"
                            :action="url"
                            :headers="headers"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            name="files[]"
                            :show-file-list=false
                            multiple
                            :file-list="fileList">
                        <el-button size="small" type="primary">上传文件</el-button>
                    </el-upload>
                </el-col>
                <span style="color:#ccc;margin-left: 20px;">支持上传zip、rar、pdf、ppt、pptx、doc、docx、xls、xlsx、jpg、jpeg、png、bmp</span>
            </el-form-item>
            <el-form-item label="文件描述:" prop="desc">
                <el-col :span="8">
                    <el-input type="textarea" v-model="form.desc"></el-input>
                </el-col>
                <el-col :span="8" style="margin-top: 25px;margin-left: 6px;">
                    <span style="color:#ccc;">(限制在50字以内)</span>
                </el-col>
            </el-form-item>
            <el-form-item label="排序:" prop="sort">
                <el-col :span="2">
                    <el-input type="number" v-model="form.sort"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="备注:" prop="">
                <el-col :span="8">
                    <el-input type="textarea" v-model="form.remarks"></el-input>
                </el-col>
                <el-col :span="8" style="margin-top: 25px;margin-left: 6px;">
                    <span style="color:#ccc;">(限制在50字以内)</span>
                </el-col>
            </el-form-item>
            <el-form-item label="查看权限:" prop="">
                <el-col :span="24">
                    <el-checkbox v-model="typeChecked">指定角色类型查看</el-checkbox>
                </el-col>
                <el-row v-if="typeChecked">
                    <el-col :span="8">
                        <div class="typeBox">
                            <div class="pageTitle">提示：选择了的角色类型中包含的所有人员都能查看该文件</div>
                            <el-form ref="formType" :model="formType" label-width="40px" class="mt20">
                                <el-form-item label="">
                                    <el-col :span="8">
                                        <el-checkbox v-model="dealerDirect">直属经销商</el-checkbox>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-checkbox v-model="dealerNotDirect">非直属经销商</el-checkbox>
                                    </el-col>
                                </el-form-item>
                               <!-- <el-form-item label="">
                                    <el-col :span="8">
                                        <el-checkbox v-model="storeDirect">直属门店</el-checkbox>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-checkbox v-model="storeNotDirect">非直属门店</el-checkbox>
                                    </el-col>
                                </el-form-item>
                                <el-form-item label="" v-for="item in staffType ">
                                    <el-col :span="8">
                                        <el-checkbox v-model="item.isChecked">{{item.type_name}}</el-checkbox>
                                    </el-col>
                                </el-form-item>-->
                            </el-form>

                        </div>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="" prop="">
                <el-col :span="24">
                    <el-checkbox v-model="memberChecked">指定人员查看</el-checkbox>
                </el-col>
                <el-row v-if="memberChecked">
                    <el-col :span="16">
                        <div class="memberType">
                            <div class="pageTitle">提示：只有选择了的人员才能看到该文件
                                <el-tabs v-model="activeName" type="card" @tab-click="handleClick"
                                         style="margin: 20px 0">
                                    <el-tab-pane label="经销商" name="first">
                                        <el-button type="primary" style="margin-bottom: 10px"
                                                   @click="addDealerVisable = 'true'">添加经销商
                                        </el-button>
                                        <el-table
                                                :data="tableData1"
                                                height="250"
                                                border
                                                @selection-change="handleSelectionChangeDealer"
                                                style="width: 100%">
                                            <el-table-column
                                                    type="selection"
                                                    width="55">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="dealer_sn"
                                                    label="经销商编号"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="dealer_name"
                                                    label="经销商名称"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="mobile"
                                                    label="手机号">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="person"
                                                    label="负责人">
                                            </el-table-column>
                                            <el-table-column
                                                    label="操作">
                                                <template slot-scope="scope">
                                                    <el-button type="text" size="small"
                                                               @click="dealerDel(scope.$index,scope.row.dealer_sn)">删除
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <el-pagination
                                                v-if="document_id"
                                                @size-change="handleSizeChange1"
                                                @current-change="handleCurrentChange1"
                                                :current-page="pageNo1"
                                                :page-sizes="[20, 50, 100, 200]"
                                                :page-size="pageSize1"
                                                layout="total, sizes, prev, pager, next, jumper"
                                                :total="totalSize1">
                                        </el-pagination>
                                        <el-button type="primary" style="margin: 10px 0" @click="delDealerMulti()">批量删除</el-button>
                                    </el-tab-pane>
                                    <!--<el-tab-pane label="门店" name="second">
                                        <el-button type="primary" style="margin-bottom: 10px"
                                                   @click="addStoreVisable = 'true'">添加门店
                                        </el-button>
                                        <el-table
                                                :data="tableData2"
                                                height="250"
                                                border
                                                @selection-change="handleSelectionChangeStore"
                                                style="width: 100%">
                                            <el-table-column
                                                    type="selection"
                                                    width="55">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="shop_sn"
                                                    label="门店编号"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="shop_name"
                                                    label="门店名称"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="address"
                                                    label="门店地址">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="mobile"
                                                    label="手机号">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="person"
                                                    label="负责人">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="isself"
                                                    label="类型">
                                            </el-table-column>
                                            <el-table-column
                                                    prop=""
                                                    label="操作">
                                                <template slot-scope="scope">
                                                    <el-button type="text" size="small" @click="storeDel(scope.$index,scope.row.shop_sn)">
                                                        删除
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <el-pagination
                                                v-if="document_id"
                                                @size-change="handleSizeChange2"
                                                @current-change="handleCurrentChange2"
                                                :current-page="pageNo2"
                                                :page-sizes="[20, 50, 100, 200]"
                                                :page-size="pageSize2"
                                                layout="total, sizes, prev, pager, next, jumper"
                                                :total="totalSize2">
                                        </el-pagination>
                                        <el-button type="primary" style="margin: 10px 0" @click="delStoreMulti()">批量删除</el-button>
                                    </el-tab-pane>
                                    <el-tab-pane label="员工" name="third">
                                        <el-button type="primary" style="margin-bottom: 10px"
                                                   @click="addWorkerVisable = 'true'">添加员工
                                        </el-button>
                                        <el-table
                                                :data="tableData3"
                                                height="250"
                                                border
                                                @selection-change="handleSelectionChangeWorker"
                                                style="width: 100%">
                                            <el-table-column
                                                    type="selection"
                                                    width="55">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="staff_sn"
                                                    label="员工编号"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="staff_name"
                                                    label="员工姓名"
                                                    width="180">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="mobile"
                                                    label="手机号">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="region"
                                                    label="管理范围">
                                                <template slot-scope="scope">
                                                    <span v-for="item in scope.row.region">{{item}}&nbsp;&nbsp;</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="type_name"
                                                    label="类型">
                                            </el-table-column>
                                            <el-table-column
                                                    prop=""
                                                    label="操作">
                                                <template slot-scope="scope">
                                                    <el-button type="text" size="small" @click="workerDel(scope.$index,scope.row.staff_sn)">删除</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <el-pagination
                                                v-if="document_id"
                                                @size-change="handleSizeChange3"
                                                @current-change="handleCurrentChange3"
                                                :current-page="pageNo3"
                                                :page-sizes="[20, 50, 100, 200]"
                                                :page-size="pageSize3"
                                                layout="total, sizes, prev, pager, next, jumper"
                                                :total="totalSize3">
                                        </el-pagination>
                                        <el-button type="primary" style="margin: 10px 0" @click="delWorkerMulyi()">批量删除</el-button>
                                    </el-tab-pane>-->
                                </el-tabs>
                            </div>
                        </div>

                    </el-col>
                </el-row>

            </el-form-item>
            <el-form-item>
                <el-col :span="8">
                    <el-button type="primary" @click="save('form')">保存</el-button>
                </el-col>
            </el-form-item>
        </el-form>

        <cateDialog
                v-if="cateDialogVisable"
                v-on:handleClose='cateDialogVisable = false'
                @pushData="getCateInfo"></cateDialog>
        <addDealer v-if="addDealerVisable"
                   v-on:handleClose='addDealerVisable = false'
                   :pushData="tableData1"
                   :type="type"
                   :source="source"
                   :notice_id="document_id"
                   @submit="getDealerInfo"
                   @onSearch="getDetails"
                   @refresh="getEditDealer">

        </addDealer>
        <addStore
                v-if="addStoreVisable"
                v-on:handleClose='addStoreVisable = false'
                :type="type"
                :source="source"
                :notice_id="document_id"
                :pushData="tableData2"
                @submit="getStoreInfo"
                @onSearch="getDetails"
                @refresh="getEditStore">

        </addStore>
        <addWorker
                v-if="addWorkerVisable"
                v-on:handleClose='addWorkerVisable = false'
                :type="type"
                :source="source"
                :notice_id="document_id"
                :pushData="tableData3"
                @submit="getWorkerInfo"
                @onSearch="getDetails"
                @refresh="getEditWorker">

        </addWorker>
    </div>
</template>

<script>
    import cateDialog from '@/common/cateDialog';
    import addDealer from '@/common/addDealer';
    import addStore from '@/common/addStore';
    import addWorker from '@/common/addWorker';
    const validateAcquaintance = (rule, value, callback) => {
        if (!value) {
            callback(new Error('必须输入排序'))
        }
        value = Number(value)
        if (typeof value === 'number' && !isNaN(value)) {
            if (value < 0 || value > 1000) {
                callback(new Error('排序在 0 至 1000 之间'))
            } else {
                callback()
            }
        } else {
            callback(new Error('排序必须为数字'))
        }
    }

    export default {
        name: "add-file",
        data() {
            return {
                source:'文件',//弹窗内区别是文件还是公告，公用
                url:'',
                cateDialogVisable: false,
                addDealerVisable: false,
                addStoreVisable: false,
                addWorkerVisable: false,
                noCate: '不分类',
                form: {
                    title:'',
                    sort:0,
                    desc:'',
                    remarks:'',
                    name:'',
                    category_id1:'',
                    category_id2:'',
                },
                formType: {},
                typeChecked: '',
                memberChecked: '',
                dealerDirect: '',
                dealerDirect: '',
                dealerNotDirect: '',
                storeDirect: '',
                storeNotDirect: '',
                areaManager: '',
                salesman: '',
                customType: '',
                activeName: 'first',
                tableData1: [],
                multipleSelectionDealer: [],
                //分页
                pageNo1: 1,
                pageSize1: 20,
                totalSize1: 0,
                tableData2: [],
                multipleSelectionStore: [],
                //分页
                pageNo2: 1,
                pageSize2: 20,
                totalSize2: 0,
                pageNo3: 1,
                pageSize3: 20,
                totalSize3: 0,
                tableData3: [],
                multipleSelectionWorker: [],
                rules: {
                    name: [
                        { required: true, message: '请上传文件。。', trigger: 'change' }
                    ],
                    category_id1: [
                        { required: true, message: '请选择分类', trigger: 'change' }
                    ],
                    desc:[
                        { required: true, message: '请填写文件描述', trigger: 'blur' }
                    ],
                    sort: [
                        /*{
                            required: true,
                            message: '请输入排序',
                            trigger: 'blur'
                        }, {
                            type: 'number',
                            message: '排序必须为数字',
                            trigger: 'blur'
                        },*/
                        {
                            required: true,
                            message: '请输入排序',
                        },
                        {
                            validator: validateAcquaintance, // 自定义验证
                            trigger: 'blur'
                        }
                    ]
                },
                cateLevelOneName:'',
                cateLevelTwoName:'',
                categoryOne:[],
                categoryTwo:[],
                fileList: [],
                headers:{
                },
                staffType:[],
                fileArr:[],

                type:0,//默认2为编辑，1为新增
                document_id:'',//传到子组件
                /*编辑的时候保存sn*/
                dealer_list:[],
                shop_list:[],
                staff_list:[]
            };
        },
        methods:
            {
                //获取员工类型
                getStaffType(){
                    this.$get('logistics','/staffs.types', {
                        per_page:10000,
                        page:1
                    }).then(res => {
                        if(res.data.length){
                            for (var i = 0; i < res.data.length; i++) {
                                res.data[i].isChecked = false;
                            }
                        }

                        this.staffType = res.data;
                        if(this.$route.query.document_id){
                            this.getDetails();
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                // 获取分类
                getCataOne(){
                    this.$get('logistics', '/categories.one', {
                        lang:'',
                        type:2
                    }).then(res => {
                        this.categoryOne = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                //选择一级分类
                selectCateOne(val){
                    this.form.category_id1 = val;
                    this.categoryTwo = [];
                    this.form.category_id2 = '';
                    this.getCateTwo();
                },
                getCateTwo(){
                    this.$get('logistics','/categories.two', {
                        lang:'',
                        type:2,
                        pid:this.form.category_id1
                    }).then(res => {
                        this.categoryTwo = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                refresh(){
                    this.getCataOne();
                    this.form.category_id1 = '';
                    this.form.category_id2 = '';
                },
                getCateInfo(val){
                    this.cateLevelOneName = val.label1;
                    this.cateLevelTwoName = val.label2;
                },
                //选择分类
                selectCate() {
                    this.cateDialogVisable = true;
                },
                edit() {
                },
                //删除
                del() {
                    this.$confirm('确定要删除吗？可多选批量删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });

                },
                /*分页*/
                handleSizeChange(val) {
                    this.pageSize = val;
                    this.pageNo = 1;
                    this.onSearch();
                },
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.onSearch();
                },
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                },
                //上传
                handleSuccess(response, file, fileList) {
                    console.log(response);
                    if(this.form.name == ''){
                        this.form.name += file.name;
                    }else{
                        this.form.name = this.form.name + "," + file.name;
                    }
                    this.fileArr.push(response.data[0]);
                },
                handleError(err, file, fileList){
                    this.$message({
                        message: JSON.parse(err.message).message,
                        type: 'error'
                    });

                },
                handleRemove(file, fileList) {
                    console.log(file, fileList);
                },
                handlePreview(file) {
                    console.log(file);
                },
                beforeRemove(file, fileList) {
                    return this.$confirm(`确定移除 ${ file.name }？`);
                },

                //获取经销商信息
                getDealerInfo(val) {
                    if (val.length && val.length >= 1) {
                        for (var i = 0; i < val.length; i++) {
                            this.tableData1.push(val[i])
                        }
                    } else {
                        this.tableData1.push(val);
                    }
                },
                //获取门店信息
                getStoreInfo(val) {
                    if (val.length && val.length >= 1) {
                        for (var i = 0; i < val.length; i++) {
                            this.tableData2.push(val[i])
                        }
                    } else {
                        this.tableData2.push(val);
                    }
                },
                //获取员工信息
                getWorkerInfo(val) {
                    console.log(val);
                    if (val.length && val.length >= 1) {
                        for (var i = 0; i < val.length; i++) {
                            this.tableData3.push(val[i])
                        }
                    } else {
                        this.tableData3.push(val);
                    }
                },
                //经销商删除
                dealerDel(index,dealer_sn) {
                    if(this.$route.query.document_id){
                        let url = '/documents/' + this.document_id +'/designee',snArr = [];
                        snArr.push(dealer_sn);
                        this.$post('logistics', url, {
                            lang:'',
                            notice:this.document_id,
                            _method:'DELETE',
                            designee_type:1,
                            designee_sns:snArr
                        }).then(res => {

                            this.getDetails();
                            this.getEditDealer();
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                        }).catch(function (error) {
                            console.log(error);
                        });
                        return;
                    }
                    this.tableData1.splice(index, 1);
                },
                //经销商批量删除
                delDealerMulti() {
                    if (this.multipleSelectionDealer.length == 0) {
                        this.$message.error('请勾选数据...');
                        return;
                    }
                    if(this.$route.query.document_id){
                        let url = '/documents/' + this.document_id +'/designee',snArr = [];
                        for(var i = 0; i < this.multipleSelectionDealer.length;i++){
                            snArr.push(this.multipleSelectionDealer[i].dealer_sn);
                        }
                        this.$post('logistics', url, {
                            lang:'',
                            notice:this.document_id,
                            _method:'DELETE',
                            designee_type:1,
                            designee_sns:snArr
                        }).then(res => {
                            this.getDetails();
                            this.getEditDealer();
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                        }).catch(function (error) {
                            console.log(error);
                        });
                        return;
                    }
                    this.arrayRiff(this.tableData1, this.multipleSelectionDealer);
                },
                handleSelectionChangeDealer(val) {
                    this.multipleSelectionDealer = val;
                },
                //门店删除
                storeDel(index,shop_sn) {
                    if(this.$route.query.document_id){
                        let url = '/documents/' + this.document_id +'/designee',snArr = [];
                        snArr.push(shop_sn);
                        this.$post('logistics', url, {
                            lang:'',
                            notice:this.document_id,
                            _method:'DELETE',
                            designee_type:2,
                            designee_sns:snArr
                        }).then(res => {

                            this.getDetails();
                            this.getEditStore();
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                        }).catch(function (error) {
                            console.log(error);
                        });
                        return;
                    }
                    this.tableData2.splice(index, 1);
                },
                //门店批量删除
                handleSelectionChangeStore(val) {
                    this.multipleSelectionStore = val;
                },
                delStoreMulti() {
                    if (this.multipleSelectionStore.length == 0) {
                        this.$message.error('请勾选数据...');
                        return;
                    }
                    if(this.$route.query.notice_id){
                        let url = '/documents/' + this.document_id +'/designee',snArr = [];
                        for(var i = 0; i < this.multipleSelectionStore.length;i++){
                            snArr.push(this.multipleSelectionStore[i].shop_sn);
                        }
                        this.$post('logistics', url, {
                            lang:'',
                            notice:this.document_id,
                            _method:'DELETE',
                            designee_type:2,
                            designee_sns:snArr
                        }).then(res => {
                            this.getDetails();
                            this.getEditStore();
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                        }).catch(function (error) {
                            console.log(error);
                        });
                        return;
                    }
                    this.arrayRiff(this.tableData2, this.multipleSelectionStore);
                },
                //员工删除
                workerDel(index,staff_sn){
                    if(this.$route.query.document_id){
                        let url = '/documents/' + this.document_id +'/designee',snArr = [];
                        snArr.push(staff_sn);
                        this.$post('logistics', url, {
                            lang:'',
                            notice:this.document_id,
                            _method:'DELETE',
                            designee_type:3,
                            designee_sns:snArr
                        }).then(res => {

                            this.getDetails();
                            this.getEditWorker();
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                        }).catch(function (error) {
                            console.log(error);
                        });
                        return;
                    }


                    this.tableData3.splice(index, 1);
                },
                //员工批量删除
                handleSelectionChangeWorker(val){
                    this.multipleSelectionWorker = val;
                },
                delWorkerMulyi(){
                    if(this.multipleSelectionWorker.length == 0){
                        this.$message.error('请勾选数据...');
                        return;
                    }
                    if(this.$route.query.document_id){
                        let url = '/documents/' + this.document_id +'/designee',snArr = [];
                        for(var i = 0; i < this.multipleSelectionDealer.length;i++){
                            snArr.push(this.multipleSelectionDealer[i].staff_sn);
                        }
                        this.$post('logistics', url, {
                            lang:'',
                            notice:this.document_id,
                            _method:'DELETE',
                            designee_type:3,
                            designee_sns:snArr
                        }).then(res => {
                            this.getDetails();
                            this.getEditWorker();
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                        }).catch(function (error) {
                            console.log(error);
                        });
                        return;
                    }
                    this.arrayRiff(this.tableData3, this.multipleSelectionWorker);
                },

                //数组删除(比较重复删除)
                arrayRiff(a, b) {
                    for (var i = 0; i < b.length; i++) {
                        for (var j = 0; j < a.length; j++) {
                            if (a[j].id == b[i].id) {
                                a.splice(j, 1);
                                j = j - 1;
                            }
                        }
                    }
                    return a;
                },
                arrayRiffCheckbox(a, b) {
                    for (var i = 0; i < b.length; i++) {
                        for (var j = 0; j < a.length; j++) {
                            if (a[j].id == b[i] - 0) {
                                a[j].isChecked = true;
                            }
                        }
                    }
                    return a;
                },
                save(formName){

                    if(this.typeChecked){
                        if(!this.dealerDirect && !this.dealerNotDirect){
                            this.$message({
                                type: 'error',
                                message: '请选择指定角色类型。。'
                            });
                            return;
                        }
                    }
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            if(this.$route.query.document_id){
                                let staffArr = [];
                                for(var i =0; i < this.staffType.length;i++){
                                    if(this.staffType[i].isChecked){
                                        staffArr.push(this.staffType[i].id);
                                    }
                                }
                                let cateId = '',dealer_list= [],shop_list =[],staff_list =[],file_name=[],file_domain=[],file_path=[];
                                if(this.form.category_id2){
                                    cateId =this.form.category_id2;
                                }else{
                                    cateId = this.form.category_id1 || '';
                                }
                                //处理数组
                                for(var i = 0; i < this.tableData1.length;i++){
                                    dealer_list.push(this.tableData1[i].dealer_sn);
                                }
                                for(var i = 0; i < this.tableData2.length;i++){
                                    shop_list.push(this.tableData2[i].shop_sn);
                                }
                                for(var i = 0; i < this.tableData3.length;i++){
                                    staff_list.push(this.tableData3[i].staff_sn);
                                }
                                for(var i = 0; i < this.fileArr.length; i++){
                                    file_name.push(this.fileArr[i].file_name);
                                    file_domain.push(this.fileArr[i].file_domain);
                                    file_path.push(this.fileArr[i].file_path);
                                }
                                let staffIDArr = [];
                                for(var i =0; i < this.staffType.length;i++){
                                    if(this.staffType[i].isChecked){
                                        staffIDArr.push(this.staffType[i].id);
                                    }
                                }
                                this.$put('logistics', '/documents/' +this.$route.query.document_id, {
                                    lang:'',
                                    _method:'PUT',
                                    category_id:cateId,
                                    sort:this.form.sort,
                                    remarks:this.form.remarks,
                                    desc:this.form.desc,
                                    file_name:file_name,
                                    file_domain:file_domain,
                                    file_path:file_path,
                                    role_push:this.fomateChecked(this.typeChecked),
                                    dealer_directly:this.fomateChecked(this.dealerDirect),
                                    dealer_not_directly:this.fomateChecked(this.dealerNotDirect),
                                    shop_directly:this.fomateChecked(this.storeDirect),
                                    shop_not_directly:this.fomateChecked(this.storeNotDirect),
                                    staff_types:staffArr,
                                    detail_push:this.fomateChecked(this.memberChecked),
                                    dealer_list:dealer_list,
                                    shop_list:shop_list,
                                    staff_list:staff_list
                                }).then(res => {
                                    this.$message({
                                        type: 'success',
                                        message: '修改成功'
                                    });
                                    this.$router.push({name:'liabraryList'});
                                }).catch(error =>{
                                    this.$message({
                                        type: 'error',
                                        message: error.message
                                    });

                                });


                                return;
                            }
                            let cateId = '',dealer_list= [],shop_list =[],staff_list =[],file_name=[],file_domain=[],file_path=[];
                            if(this.form.category_id2){
                                cateId =this.form.category_id2;
                            }else{
                                cateId = this.form.category_id1 || '';
                            }
                            if(this.memberChecked && this.tableData1.length == 0){
                                this.$message({
                                    type: 'error',
                                    message: '请选择经销商。。'
                                });
                                return;
                            }
                            //处理数组
                            for(var i = 0; i < this.tableData1.length;i++){
                                dealer_list.push(this.tableData1[i].dealer_sn);
                            }
                            for(var i = 0; i < this.tableData2.length;i++){
                                shop_list.push(this.tableData2[i].shop_sn);
                            }
                            for(var i = 0; i < this.tableData3.length;i++){
                                staff_list.push(this.tableData3[i].staff_sn);
                            }
                            for(var i = 0; i < this.fileArr.length; i++){
                                file_name.push(this.fileArr[i].file_name);
                                file_domain.push(this.fileArr[i].file_domain);
                                file_path.push(this.fileArr[i].file_path);
                            }
                            let staffIDArr = [];
                            for(var i =0; i < this.staffType.length;i++){
                                if(this.staffType[i].isChecked){
                                    staffIDArr.push(this.staffType[i].id);
                                }
                            }
                            this.$post(this.global + '/documents', {
                                lang:'',
                                category_id:cateId,
                                sort:this.form.sort,
                                remarks:this.form.remarks,
                                desc:this.form.desc,
                                file_name:file_name,
                                file_domain:file_domain,
                                file_path:file_path,
                                role_push:this.fomateChecked(this.typeChecked),
                                dealer_directly:this.fomateChecked(this.dealerDirect),
                                dealer_not_directly:this.fomateChecked(this.dealerNotDirect),
                                shop_directly:this.fomateChecked(this.storeDirect),
                                shop_not_directly:this.fomateChecked(this.storeNotDirect),
                                staff_types:staffIDArr,
                                detail_push:this.fomateChecked(this.memberChecked),
                                dealer_list:dealer_list,
                                shop_list:shop_list,
                                staff_list:staff_list
                            }).then(res => {
                                this.$message({
                                    type: 'success',
                                    message: '添加成功'
                                });
                                this.$router.push({name:'liabraryList'});
                            }).catch(error =>{
                                this.$message({
                                    type: 'error',
                                    message: error.message
                                });

                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });


                },
                fomateChecked(val){
                    if(val){
                        return 1
                    }else{
                        return 0
                    }

                },
                formatDetail(val){
                    if(val == 1){
                        return true
                    }else{
                        return false
                    }
                },
                //编辑的时候批量获取经销商
                getEditDealer(){
                    this.$post('logistics', '/dealers.batchs', {
                        lang:'',
                        per_page:this.pageSize1,
                        page:this.pageNo1,
                        dealer_sns:this.dealer_list.join(',')
                    }).then(res => {
                        this.tableData1 = res.data;
                        if(res.data.length == 0){
                            this.totalSize1 = 0;
                            return;
                        }
                        this.totalSize1 = res.meta.total;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
               /* //编辑的时候获取门店
                getEditStore(){
                    this.$post(this.global + '/shops.batchs', {
                        lang:'',
                        per_page:this.pageSize2,
                        page:this.pageNo2,
                        shop_sns:this.shop_list.join(',')
                    }).then(res => {
                        this.tableData2 = res.data;
                        this.totalSize2 = res.meta.total;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                //编辑的时候获取员工
                getEditWorker(){
                    this.$post(this.global + '/staffs.batchs', {
                        lang:'',
                        per_page:this.pageSize3,
                        page:this.pageNo3,
                        staff_sns:this.staff_list.join(',')
                    }).then(res => {
                        this.tableData3 = res.data;
                        this.totalSize3 = res.meta.total;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },*/
                //编辑查询详情
                getDetails(){
                    this.document_id = this.$route.query.document_id;
                    this.$get('logistics','/documents/' + this.$route.query.document_id, {
                        lang:'',
                        document:this.$route.query.document_id
                    }).then(res => {
                        //console.log(res);
                        this.form.category_id2 = res.data.category_id;
                        this.form.category_id1 = res.data.pid;
                        this.$get('logistics','/categories.two', {
                            lang:'',
                            type:2,
                            pid:res.data.pid
                        }).then(res => {
                            this.categoryTwo = res.data;
                        }).catch(function (error) {
                            console.log(error);
                        });
                        this.form.desc = res.data.desc;
                        this.form.remarks = res.data.remarks;
                        this.form.sort = res.data.sort;
                        this.form.name = res.data.name;
                        this.dealer_list = res.data.config.dealer_list;
                        this.shop_list = res.data.config.shop_list;
                        this.staff_list = res.data.config.staff_list;
                        this.getEditDealer();
                        //this.getEditStore();
                        //this.getEditWorker();
                        this.typeChecked = this.formatDetail(res.data.config.role_push);
                        this.dealerDirect = this.formatDetail(res.data.config.dealer_directly);
                        this.dealerNotDirect = this.formatDetail(res.data.config.dealer_not_directly);
                        this.storeDirect = this.formatDetail(res.data.config.shop_directly);
                        this.storeNotDirect = this.formatDetail(res.data.config.shop_not_directly);
                        this.memberChecked = this.formatDetail(res.data.config.detail_push);
                        if(res.data.config.staff_types.length) {
                            this.staffType = this.arrayRiffCheckbox(this.staffType, res.data.config.staff_types);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                //指定人员发布（分布）
                /*分页*/
                handleSizeChange1(val) {
                    this.pageSize1 = val;
                    this.pageNo1 = 1;
                    this.getEditDealer();
                },
                handleCurrentChange1(val) {
                    this.pageNo1 = val;
                    this.getEditDealer();

                },
                handleSizeChange2(val) {
                    this.pageSize2 = val;
                    this.pageNo2 = 1;
                    this.getEditStore();
                },
                handleCurrentChange2(val) {
                    this.pageNo2 = val;
                    this.getEditStore();

                },
                handleSizeChange3(val) {
                    this.pageSize3 = val;
                    this.pageNo3 = 1;
                    this.getEditWorker();
                },
                handleCurrentChange3(val) {
                    this.pageNo3 = val;
                    this.getEditWorker();

                },
                handleClick(tab, event) {
                }
            },

        created() {
            //localStorage.setItem('access_tokens',this.$cookie.get('access_tokens'));
           /* this.headers = {
                'Authorization':'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImViNmE5Y2JiNTUwOTc0ZmYwMGE0MWE5NWE0ODU2N2UwNDczNDA4MzJhMzY2NWJiMDhmNWE0ZDczNTQ0Mzg4NDU5NDc1MjkwYTU0N2EyMjYwIn0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6ImViNmE5Y2JiNTUwOTc0ZmYwMGE0MWE5NWE0ODU2N2UwNDczNDA4MzJhMzY2NWJiMDhmNWE0ZDczNTQ0Mzg4NDU5NDc1MjkwYTU0N2EyMjYwIiwiaWF0IjoxNTYwMzIwOTA5LCJuYmYiOjE1NjAzMjA5MDksImV4cCI6MTU2MTYxNjkwOSwic3ViIjoiMjIiLCJzY29wZXMiOlsiKiJdfQ.OIdVR_Iu9ZUinHE6p8B3HEKmjslOZMIAiqXJ3bMKOKi9RSjNfPmJFNmjUiNarszPeCzIMHLDMRB9wYDhm8gjKIxPnqv1oBpugnWBCTRXkdkIrwQgsESA6IigfKZjQS7kDTZl-JBwXGL3jig0LuLnPkC8-ORLMYZos0KojBXeAHCDev-W3LsTB2VPls2999Dw56mrlEJT1eYxtjhCwbu8giakqfZTaGkSEfWscsKZPh5QaUHZ3Dv7t0tXolEdRnwC02angdEDtsCufei8nMy48fiHXxxn3S_bNx_5A2zKGTTrg3JysLzTFsrsojyETWVE0_W3osAtC4vRMwGaIhPU3pTir-Z666ETgkdRVRcXbjTnxvU3Wh7E8yW35Yv312IhttTEBSu4xNqtIhVEkQ3BnpAWmfmpCAqypxUTzJ3albwqUhx24ORQ9ge8xuohPEnUs2-ntGbt8qPrOF-eBJZjD9ErB9gnDK9Qqc9Zayf-FY35en9y6Y4rioEZAIZJC3zGdIUX5D5mgldHo3HF-a0l7ZSf9daefj2JYVQdvIEniVIhYab-RPC3VghqJ2EXYIkmDYYzDLkwK-A8b9MkIAQ53nXFXF671jP2U3aTfa76LpVk-73sfS8XeFHhudGYaEDIWrcPXAqK_3kuG_LnBGSYl0_csgdDRmVOsX4bUWW2byA'
            }*/
            this.headers.Authorization ='Bearer' + " " +localStorage.getItem('access_token');
            this.url = this.global + '/uploads/files';
            this.getCataOne();
        },
        mounted(){
            this.$nextTick(function(){
                this.getStaffType();

            })
        },
        components: {
            cateDialog, addDealer, addStore, addWorker
        }
    }
</script>

<style lang="scss" scoped>
    .typeBox {
        //height: 180px;
        border: 1px solid #ccc;
        padding: 10px;
    }

    .memberType {
        height: 520px;
        //overflow: scroll;
        border: 1px solid #ccc;
        padding: 10px;
    }


</style>